import { useQuery } from '@mint-lib/query-client';
import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const defaultList: ApprovalFlows.FlowItemLite[] = [];

const useFlowListData = () => {
  return useQuery({
    ...ApprovalFlows.listFlows({
      data: {
        sort: 'asc',
        options: [],
      },
    }),
    select: (data) => data.data?.items ?? defaultList,
  });
};

export default useFlowListData;
